import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-302ed02c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "avatar-upload-pc"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-close"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "更换头像", -1));
const _hoisted_6 = {
  class: "frame"
};
const _hoisted_7 = {
  class: "cropper-box"
};
const _hoisted_8 = {
  class: "buttons"
};
const _hoisted_9 = {
  class: "frame"
};
const _hoisted_10 = {
  class: "user-icon"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "upload"
}, "上传图片", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Cropper = _resolveComponent("Cropper");
  const _component_van_uploader = _resolveComponent("van-uploader");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "popup-overlay",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.close && $setup.close(...args))
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "button-close",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.close && $setup.close(...args))
  }, _hoisted_4), _hoisted_5, _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_Cropper, {
    class: "cropper",
    src: $setup.avatarImgUrl,
    "auto-zoom": true,
    "stencil-props": {
      aspectRatio: 1
    },
    onChange: $setup.change
  }, null, 8, ["src", "onChange"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
    class: "back",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.back && $setup.back(...args))
  }), _createElementVNode("button", {
    class: "save",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.uploadImage && $setup.uploadImage(...args))
  })])])], 512), [[_vShow, $setup.editMode]]), _withDirectives(_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    class: "avatar",
    src: $setup.avatarImgUrl
  }, null, 8, _hoisted_11)]), _createVNode(_component_van_uploader, {
    modelValue: $setup.myAvatar,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.myAvatar = $event),
    "max-size": $setup.maxAvatarSize,
    onOversize: $setup.onOversize,
    "before-read": $setup.beforeRead,
    "after-read": $setup.afterRead,
    "preview-image": false
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["modelValue", "max-size", "onOversize", "before-read", "after-read"])], 512), [[_vShow, !$setup.editMode]])])]);
}